import { Link } from 'react-router-dom';
import Text from 'shared/components/Text/Text';
import styled from 'styled-components';

export const FAQsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    flex-direction: row;
    gap: 48px;
  }
`;

export const FAQTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
`;

export const FAQBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 20px;
`;

export const LinkStyled = styled(Link)`
  font-family: Avenir;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: fit-content;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};

  &:hover {
    color: ${({ theme }) => theme.colors.textLinkLinkSecondary2100};
  }
  &:active {
    color: ${({ theme }) => theme.colors.textLinkLinkVisitedFunction4100};
  }
`;

export const IconContainer = styled.div`
  display: flex;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  margin-bottom: 16px;
  background: ${({ theme }) => theme.colors.backgroundSecondaryGrey05};
  box-shadow: ${({ theme }) => theme.elevations.extraSunken};
  svg {
    margin: auto;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin-bottom: 24px;
  }
`;
